const generatePageTitle = (page: string) => `Foodie Buddies Pod | ${page}`;

export default generatePageTitle;
